module.exports = __webpack_public_path__ + "static/img/drawer3.3d63026.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/page/drawer/drawer3.png
// module id = sdOu
// module chunks = 12